import React, { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, A11y } from "swiper";

import { TeaserCard } from "../TeaserCard/TeaserCard";

import * as styles from "./TeaserGrid.module.less";

export function TeaserGrid({
    teaserList = [],
    sliderOnMobile = false,
    semanticOfTeaserHeadline,
    TypeSpecificContent,
    maxElements = 3,
    hasLightBackground,
    teaserClass
}) {
    const slicededTeaserList = useMemo(() => {
        return [...teaserList.slice(0, maxElements)];
    }, [teaserList, maxElements]);

    return (
        <>
            <div
                className={
                    sliderOnMobile
                        ? styles.desktopTeasers
                        : styles.mobileGridTeasers
                }
            >
                {slicededTeaserList.map((teaserElement) => {
                    const {
                        type,
                        teaserImage: image,
                        teaserTagline: tagline,
                        teaserHeadline: headline,
                        division,
                        teaserDocument: document,
                        teaserText: text,
                        teaserLink: link,
                        teaserUrl: url,
                        teaserButtonLabel: buttonLabel
                    } = teaserElement;

                    return (
                        <TeaserCard
                            key={teaserElement.id}
                            cardClass={teaserClass}
                            hasLightBackground={hasLightBackground}
                            fullWidthOnMobile={!sliderOnMobile}
                            teaserData={{
                                type,
                                image,
                                tagline,
                                headline,
                                semanticOfHeadline: semanticOfTeaserHeadline,
                                division,
                                text,
                                link,
                                url,
                                buttonLabel,
                                document
                            }}
                        >
                            {TypeSpecificContent && (
                                <TypeSpecificContent {...teaserElement} />
                            )}
                        </TeaserCard>
                    );
                })}
            </div>

            {sliderOnMobile && (
                <div className={styles.mobileTeasers + " mobileTeasers"}>
                    <Swiper
                        className={styles.teaserSwiper}
                        modules={[Navigation, Pagination, Autoplay, A11y]}
                        slidesPerView={1.125}
                        watchSlidesProgress={true}
                        loop={true}
                        autoplay={{
                            delay: 5000
                        }}
                    >
                        {teaserList.map((teaserElement) => {
                            const {
                                type,
                                teaserImage: image,
                                teaserTagline: tagline,
                                teaserHeadline: headline,
                                division,
                                teaserDocument: document,
                                teaserText: text,
                                teaserLink: link,
                                teaserUrl: url,
                                teaserButtonLabel: buttonLabel
                            } = teaserElement;

                            return (
                                <SwiperSlide
                                    className={styles.teaserSlide}
                                    key={teaserElement.id}
                                >
                                    <TeaserCard
                                        hasLightBackground={hasLightBackground}
                                        teaserData={{
                                            type,
                                            image,
                                            tagline,
                                            headline,
                                            semanticOfHeadline:
                                                semanticOfTeaserHeadline,
                                            division,
                                            text,
                                            link,
                                            url,
                                            buttonLabel,
                                            document
                                        }}
                                    >
                                        {TypeSpecificContent && (
                                            <TypeSpecificContent
                                                {...teaserElement}
                                            />
                                        )}
                                    </TeaserCard>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            )}
        </>
    );
}
